import PropTypes from "prop-types";

export const CustomerShape = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  idNumber: PropTypes.string
});

export const IssueShape = PropTypes.shape({
  text: PropTypes.string,
  updated: PropTypes.number,
  created: PropTypes.number,
  status: PropTypes.string
});



// WEBPACK FOOTER //
// ./src/common/proptypes.js